export interface IAd2cpSensor {
    blank:number,
    cell_size:number,
    win_size:number,
    position:number,
    cells:Array<string>
}

export const getDefaultAd2cpSensor = ():IAd2cpSensor => {
    return {
        blank:0.2,
        cell_size:2,
        win_size:4,
        position:0,
        cells:["2","3","4","5","6"]
    }
}